var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.297,
    height: 48,
    className: "search_svg__icon",
    viewBox: "0 0 1137 1024"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@font-face{font-family:feedback-iconfont;src:url(//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944)format(\"woff2\"),url(//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944)format(\"woff\"),url(//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944)format(\"truetype\")}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M744.243 729.242a409.6 409.6 0 1 1-579.277-579.277 409.6 409.6 0 0 1 579.277 579.277m-72.448-72.448a307.2 307.2 0 1 0-434.432-434.432 307.2 307.2 0 0 0 434.432 434.432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m642.867 751.514 72.448-72.448 162.919 162.918-72.448 72.448z"
  })));
};
export default SvgSearch;